import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
  alt?: string;
  style?: React.CSSProperties;
  priority?: boolean; // for above-the-fold images
  src?: string; // override the asset (e.g. icon-only mark)
}

export function Logo({
  className = "h-12 w-12",
  alt = "OdyVoy - AI travel planning app logo",
  style,
  priority = false,
  src = "/lovable-uploads/odyvoy-logo.png"
}: LogoProps) {
  const imageSrc = src;

  
  return (
    <img
      src={imageSrc}
      alt={alt}
      className={cn("bg-transparent", className)}
      style={style}
      loading={priority ? "eager" : "lazy"}
      {...(priority ? { fetchpriority: "high" } : {})}
      decoding="async"
      width="500"
      height="500"
    />
  );
}